import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import global from './model/global'
import sign from './model/sign'
export default new Router({
  mode: 'hash',
  base: process.env.VUE_APP_BASE,
  routes: [
    ...sign,
    ...global
  ]
})
